import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { Modal, Input, message, Popconfirm, Spin, Button, Radio, Checkbox, Icon, Slider } from 'antd';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';
import ReactAvatarEditor from 'react-avatar-editor';

export default class MediaQuestionEditModule extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      pageId: props.pageId,
      studentIds: props.studentIds,
      area: props.area,
      question: props.area.question_areas[0],
      btnState:{
        disabled: false,
        loading: false,
      },
      scale: 1,
      rotate: 0,
      needSubmit: false,

      uploading:false,
      uploadedFiles: [],
      uploadingFiles: [],
    };
    // bind this
    this.submit = this.submit.bind(this);
    this.onImageUpate = this.onImageUpate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRotate = this.handleRotate.bind(this);
    this.setEditorRef = this.setEditorRef.bind(this);
    this.getBlobBydataURI = this.getBlobBydataURI.bind(this);
    this._questionDetailView = this._questionDetailView.bind(this);

    //upload
    this.getAvailableQuotaForUploadingFiles = this.getAvailableQuotaForUploadingFiles.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);


  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  componentWillReceiveProps(newProps){
    if(newProps.area.question_areas[0].questionToJson.answer){
      this.setState({
        area: newProps.area,
        question: newProps.area.question_areas[0],
        scale: 1,
        rotate: 0,
        uploading:false,
        btnState: {
          disabled: false,
          loading: false,
        },
        uploadedFiles: [],
        uploadingFiles: [],
      })
    }
  }

  toolAnswers(pushAnswer) {
    var that = this;
    if (pushAnswer) {
      let { hasAnswer, questionId, data } = pushAnswer;
      DataService.toolAnswers(hasAnswer, questionId, data).then((res) => {
        that.setState({
          btnState: {
            disabled: false,
            loading: false,
            text: '确认',
          },
          needSubmit: false,
        })
        console.log("update")
        this.state.question.hasAnswer = true;
        this.props.onUpdate(this.state.area.id, [this.state.question])
        this.props.onCancel()
      }).catch((error) => {
        message.error("提交失败")
        that.setState({
          btnState: {
            disabled: false,
            loading: false,
            text: '确认',
          }
        })
        console.log(error);
      })
    }
  }

  _questionDetailView(question) {
    let q = question.questionToJson;
    let that  = this;

    switch (question.type) {

      case "Image":
        return (
          <div key={question.id}>
            <div className="question-title">图片{q.title ? "："+q.title : ""}</div>
            <div className="question-cancel" onClick={this.props.onCancel}></div>
            <div className="question-description-img">图片缩放</div>
            <div style={{width:"100%", hieght:"100%", textAlign:"center"}}>
              <ReactAvatarEditor
                  ref={this.setEditorRef}
                  image={q.answer.url}
                  width={this.state.rotate == 90 || this.state.rotate == 270 ? question.height : question.width}
                  height={this.state.rotate == 90 || this.state.rotate == 270 ? question.width : question.height}
                  border={40}
                  color={[0, 0, 0, 0.4]} // RGBA
                  scale={this.state.scale}
                  rotate={this.state.rotate}
                  crossOrigin="anonymous"
              />
            </div>
            <Icon className="question-img-rotate" type="reload" onClick={this.handleRotate} />
            <div className="question-description-img-slider">
              <Icon className="img-slider-icon-minus" type="minus"/>
              <Slider className="img-slider" onChange={this.handleChange} tipFormatter={null} step={0.1} defaultValue={1} min={1} max={3} />
              <Icon className="img-slider-icon-plus" type="plus" />
            </div>
          </div>
        )

      case "Video":
        return (
          <div key={question.id}>
            <div className="question-title">视频</div>
            <div className="question-cancel" onClick={this.props.onCancel}></div>
            <div className="question-audio">
              <video controls="controls" width="300px" >当前浏览器不支持播放视频
                <source src={q.answer.url} type="video/mp4" />
              </video>
            </div>
          </div>
        )

      case "Audio":
        return (
          <div key={question.id}>
            <div className="question-title">录音</div>
            <div className="question-cancel" onClick={this.props.onCancel}></div>
            <div className="question-audio">
              <audio controls="controls">
                <source src={q.answer.url} type="audio/mp3" />
                <source src={q.answer.url} type="audio/ogg" />
                <source src={q.answer.url} type="audio/mpeg" />
              </audio>
            </div>
          </div>
        )
    }
  }

  handleRotate(){
    let rotate = this.state.rotate;
    if(rotate == 270){
      rotate = 0
    } else {
      rotate = rotate + 90
    }
    this.setState({
      rotate: rotate
    })
  }

  setEditorRef(editor){
    this.editor = editor;
  }

  getBlobBydataURI(dataURI,type) {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for(var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {type:type });
  }

  onImageUpate(){
    let question = this.state.question;
    let imageInfo = question.questionToJson.answer;
    if(question.type == "Image"){

      let imageHeight = (question.width / imageInfo.width) * imageInfo.height;

      if (question.height < imageHeight) {
        imageInfo.imageHeight = imageHeight;
        imageInfo.imageWidth = question.width;
        imageInfo.translateY = (imageInfo.imageHeight - question.height) / 2;
      } else {
        imageInfo.imageWidth = (question.height / imageInfo.height) * imageInfo.width;
        imageInfo.imageHeight = question.height;
        imageInfo.translateX = (imageInfo.imageWidth - question.width) / 2;
      }
    }else if(question.type == 'Video'){
      question.questionToJson.answer.imageWidth = question.width
    }

    this.setState({
      question: question,
    })
  }

  //upload
  getAvailableQuotaForUploadingFiles() {
    return true;
  }

  isAllUploadingFileFinished() {
    return !this.state.uploading && this.state.uploadedFiles.length > 0;
  }

  onFileStartUpload(newFileKey) {
    this.setState({
      uploading: true,
      btnState: {
        disabled: true,
        loading: true,
      }
    })
    return true;
  }

  onFileUploadSuccess(newFileKey, fileName, size, remoteUrl, fileAdditionalInfo) {
    let imageInfo = {
      url: remoteUrl
    }
    let type = this.state.question.type;
    if (type == 'Image') {
      imageInfo.width = fileAdditionalInfo.w;
      imageInfo.height = fileAdditionalInfo.h;
      this.state.question.questionToJson.answer = imageInfo;
      this.onImageUpate();
      this.setState({
        btnState: {
          disabled: false,
          loading: false,
        }
      })
      if(this.state.needSubmit){
        let data = {}, questionId;
        let question = this.state.question;
        data.answer = {};
        data.answer.url = question.questionToJson.answer.url;
        data.answer.width = question.questionToJson.answer.width;
        data.answer.height = question.questionToJson.answer.height;
        questionId = question.id;
        data.answer = JSON.stringify(data.answer);
        data.page_id = this.state.pageId;
        data.student_ids = JSON.stringify(this.state.studentIds);
        let p = {
          hasAnswer: question.hasAnswer,
          questionId: questionId,
          data: data,
        }
        this.toolAnswers(p);
      }
    }else if(type == "Video") {
      if(fileAdditionalInfo.length > this.state.question.questionToJson.length){
        let maxLength = parseInt(this.state.question.questionToJson.length / 60);
        maxLength > 0 ? message.warning(`上传视频请不要超过${maxLength}分钟`) : message.warning(`上传视频请不要超过${this.state.question.questionToJson.length}秒`)
      }else {
        imageInfo.length = fileAdditionalInfo.length;
        imageInfo.width = fileAdditionalInfo.w;
        imageInfo.height = fileAdditionalInfo.h;
        imageInfo.cover_image = remoteUrl + '?vframe/jpg/offset/0.5';
        this.state.question.questionToJson.answer = imageInfo;
        this.onImageUpate()
      }
    }else if(type == "Audio") {
      if(fileAdditionalInfo.length > this.state.question.questionToJson.length){
        let maxLength = parseInt(this.state.question.questionToJson.length / 60);
        maxLength > 0 ? message.warning(`上传音频请不要超过${maxLength}分钟`) : message.warning(`上传音频请不要超过${this.state.question.questionToJson.length}秒`)
      }else {
        imageInfo.length = fileAdditionalInfo.length;
        this.state.question.questionToJson.answer = imageInfo;
        this.onImageUpate()
      }
    }
    this.props.onUpdate(this.state.area.id, [this.state.question])

    this.setState({
      uploading: false,
      uploadedFiles: remoteUrl,
      question:this.state.question,
      btnState: {
        disabled: false,
        loading: false,
      }
    });
  }

  //fill questions
  handleChange(e){
   this.setState({scale: e})
  }

  submit() {
    this.setState({
      btnState: {
        disabled: true,
        loading: true,
        text: '正在提交中..'
      }
    })

    // 判断是否有答案未填写
    let submitAbled = true;
    let question = this.state.question;
    if(this.state.uploading || !this.state.question.questionToJson.answer){
      submitAbled = false;
    }

    if (submitAbled) {
      let p;
      let data = {}, questionId;
      data.answer = {};
      if (question.type == 'Image') {
        var base64Data = this.editor.getImage().toDataURL('image/jpeg');
        var file = this.getBlobBydataURI(base64Data,'image/jpeg');
        file.name = Date.now() + "web_archive.jpeg";
        file.preview = "";
        this.state.needSubmit = true;
        this.uploadModuleObj.upload(file);
        return
      }
      else if (question.type == 'Video') {
        data.answer.url = question.questionToJson.answer.url;
        data.answer.cover_image = question.questionToJson.answer.url + "?vframe/jpg/offset/0.5";
        data.answer.length = question.questionToJson.answer.length;
        questionId = question.id;
      }
      else if (question.type == 'Audio') {
        data.answer.url = question.questionToJson.answer.url;
        data.answer.length = question.questionToJson.answer.length;
        questionId = question.id;
      }
      data.answer = JSON.stringify(data.answer);
      data.page_id = this.state.pageId;
      data.student_ids = JSON.stringify(this.state.studentIds);
      p = {
        hasAnswer: question.hasAnswer,
        questionId: questionId,
        data: data,
      }
      this.toolAnswers(p); 
    } else if (!submitAbled) {
      this.setState({
        btnState: {
          disabled: false,
          loading: false,
          text: '确认'
        }
      })
    }
  }

  render() {
    let type = "";
    if(this.state.question.type == "Image"){
      type = "图片"
    }else if(this.state.question.type == "Video"){
      type= "视频"
    }else if(this.state.question.type == "Audio"){
      type = "录音"
    }
    return (
      <div className="question-box">
        <div className="question-cancel" onClick={this.props.onCancel}></div>
        {this.state.uploading &&
          <Spin>
            {this._questionDetailView(this.state.question)}
          </Spin>
        }
        {!this.state.uploading &&
          this._questionDetailView(this.state.question)
        }
        <div className="question-footer">
          <Button className="question-footer-btn" disabled={this.state.btnState.disabled} loading={this.state.btnState.loading} onClick={this.submit}>确 认</Button>
          <ReactQiniuModule
              ref={(uploadModule) => {this.uploadModuleObj = uploadModule;}}
              className="update-file"
              onSuccess={this.onFileUploadSuccess}
              onStartPermit={this.onFileStartUpload}
              isAllFinish={this.isAllUploadingFileFinished}
              getUploadQuota={this.getAvailableQuotaForUploadingFiles}
              allowUploadFileTypes={type == "图片" ? "IMAGES" :(type == "视频" ? "VIDEOS" : "AUDIOS")}
              allowUploadFileSize={type == "图片" ? 20 : (type == "视频" ? 200 : 0)} >
            <span className="question-footer-text">更换{type}</span>
          </ReactQiniuModule>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/MediaQuestionEditModule.jsx